(function ($) {
  "use strict";

  jQuery(document).on('ready', function () {
    if (window.innerWidth > 1000) {
     $('.section-eye-shape-guide-item #shopify-section-eye-shape-guide-item .show-esg-container .esg-item:nth-child(3)').after($('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details'));
    }else{
    	$('.section-eye-shape-guide-item #shopify-section-eye-shape-guide-item .show-esg-container .esg-item:nth-child(2)').after($('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details'));
    }
//     if (navigator.userAgent.indexOf('Mac OS X') != -1) {
//        $("body").addClass("mac");
//     }

    
    $('.eye-shape-guide--close').click(function(e){
       $('#shopify-section-eye-shape-guide-item').find('.btn').removeClass('minus');
      var id_item= this.getAttribute('id');
      $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item .show-esg-container .esg-item').css("opacity", "1");
      $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details .esg-item-details-container .esg-item-details-' + id_item).css("display", "none");
    	$('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details').css("display", "none");  
    });
     $('.esg-item-click').click(function(e){
       var id_item= this.getAttribute('id');
       
 		$('.esg-item .button-esg .btn').removeClass('minus');
       $('.card-esg-item-' + id_item).find('.btn').addClass('minus');

       $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item .show-esg-container .esg-item').css("opacity", "1");
//        $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item .show-esg-container .card-esg-item-'  + id_item).css("opacity", "0");
       $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details .esg-item-details-container .esg-items-details').css("display", "none");
       $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details').css("display", "block");
       $('.eye-shape-guide-body .section-eye-shape-guide-item #shopify-section-eye-shape-guide-item-details .esg-item-details-container .esg-item-details-' + id_item).css("display", "block");
       $('.slick-dots li.slick-active button').click();
           $('html, body').animate({
                      scrollTop: $('#shopify-section-eye-shape-guide-item-details').offset().top - 190
                   }, 500);
    });
    
   	
  });
})(jQuery);



